import { useCallback } from 'react';
import { AModal } from '../../../../../components';
import { IProfessional } from '../../../../../shared/interfaces';
import { useToast } from '../../../../../hooks/toast';
import { pathProfessionalResetPassword } from '../../../../../http';

interface IResetSignaturePasswordProps {
  open: boolean;
  close: () => void;
  professional: IProfessional | null;
}

const ResetSignaturePassword: React.FC<IResetSignaturePasswordProps> = ({
  open,
  close,
  professional,
}) => {
  const { addToast } = useToast();

  const handleReset = useCallback(async () => {
    await pathProfessionalResetPassword(professional?.id)
      .then(() => {
        addToast({
          type: 'success',
          title: 'Sucesso',
          description: 'Senha resetada com sucesso',
        });
        close();
      })
      .catch((error) => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: error.response.data.error ?? 'Erro ao resetar.',
        });
      });
  }, [addToast, close, professional]);

  return (
    <AModal
      open={open}
      title="Resetar senha de assinatura?"
      close={close}
      onOk={handleReset}
      okText={'Resetar'}
    >
      Deseja resetar a senha para padrão [1 a 6]?
    </AModal>
  );
};

export default ResetSignaturePassword;
